import { render, staticRenderFns } from "./AverageDaysOfStock.vue?vue&type=template&id=bcc3c06a&scoped=true"
import script from "./AverageDaysOfStock.vue?vue&type=script&lang=js"
export * from "./AverageDaysOfStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc3c06a",
  null
  
)

export default component.exports